import { computed, type MaybeRef } from 'vue';
import { useQuery } from '@tanstack/vue-query';
import { toSafeInteger } from 'lodash-es';

import { getLoyaltyCustomer } from '../api';

export function useLoyaltyCustomer({
  enabled,
}: {
  enabled?: MaybeRef<boolean>;
}) {
  const loyaltyCustomerQuery = useQuery({
    queryKey: ['loyalty', 'customer'],
    queryFn: () => getLoyaltyCustomer(),
    refetchOnWindowFocus: false,
    enabled,
  });

  const customer = computed(() => loyaltyCustomerQuery.data.value);

  const cashback = computed(() => toSafeInteger(customer.value?.cashbacks));

  const isLoading = computed(() => loyaltyCustomerQuery.isLoading.value);

  const isRefetching = computed(() => loyaltyCustomerQuery.isRefetching.value);

  function refetch() {
    return loyaltyCustomerQuery.refetch();
  }

  return {
    cashback,
    isLoading,
    isRefetching,
    refetch,
  };
}
